<template>
  <!-- 财务审核 -->
  <div class="billOperationRecord public_Spacing">
    <div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
      <div class="public_criteriaRange">
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">客户：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="customerMo"
            placeholder="请选择"
            :clearable="true"
            filterable
          >
            <el-option
              v-for="(item, index) in customerOptions"
              :key="index"
              :label="item.ORMTB421CA06"
              :value="item.ORMTB421CA08"
            >
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">提现类型：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="txlx"
            placeholder="请选择"
            :clearable="true"
            filterable
          >
            <el-option
              v-for="item in materielOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="display: flex; align-items: center;">
          <label class="public_lbSty">手机号:</label>
          <el-input
            v-model="ORMTB429CA10"
            placeholder="请输入手机号查询"
            style="height: 1.7vw!important;"
          ></el-input>
        </div>
      </div>
      <div class="public_operatArea">
        <span
          class="pulic_operatArea_now pulic_cursor"
          :class="dateNowDayActive ? 'public_dateActive' : ''"
          @click="getNowDay"
          >当日</span
        >
        <span
          class="public_operatArea_yesterday pulic_cursor"
          :class="dateYesterdayActive ? 'public_dateActive' : ''"
          @click="getYesterday"
          >昨天</span
        >
        <span
          class="pulic_operatArea_now pulic_cursor"
          :class="dateNowMonthActive ? 'public_dateActive' : ''"
          @click="sameMonth"
          >当月</span
        >
        <span
          class="public_operatArea_yesterday pulic_cursor"
          :class="dateLastMonthActive ? 'public_dateActive' : ''"
          @click="lastMonth"
          >上月</span
        >
        <div class="public_operatArea_timePicker pulic_cursor">
          <el-date-picker
            v-model="date"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            :picker-options="startDateDisabled"
            @change="datePickerChange"
            start-placeholder="开始日"
            end-placeholder="结束日"
            class="pulic_cursor"
          >
          </el-date-picker>
        </div>
        <div class="public_operatBtn">
          <el-button type="primary" @click="queryClick"
            ><i class="iconfont icon-chaxun"></i>查询</el-button
          >
          <el-button type="success" @click="exports"
            ><i class="iconfont icon-daochu"></i>导出</el-button
          >
        </div>
      </div>
    </div>
    <div class="billOperationRecord-table pulbic_table_container">
      <el-button class="right_btn" type="primary" plain
        >{{ '总金额:' + zjr + '元' }}
      </el-button>
      <el-table
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        max-height="90%"
        :default-sort="{ prop: 'waterNum', order: 'descending' }"
        :header-cell-style="{
          color: 'rgba(51,51,51,1)',
          'font-weight': 'bold',
        }"
        class="public_tableColumn"
      >
        <el-table-column prop="ORMTB410CA00" label="客户名称">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ORMTB431CA03 }}</span>
            </p>
            <p style="color: #999;">
              <span>{{ scope.row.ORMTB431CA05 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="提现类型">
          <template slot-scope="scoped">
            {{
              scoped.row.ORMTB431CA00 === 'YFTX'
                ? '运费提现'
                : scoped.row.ORMTB431CA00 === 'YETX'
                ? '余额提现'
                : scoped.row.ORMTB431CA00 === 'HK'
                ? '回款'
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="ORMTB431CA01" label="金额"> </el-table-column>
        <el-table-column prop="ORMTB431CA02" label="到账时间">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="DetailsClick(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="提现详情"
        :visible.sync="oerderDetilsShow"
        width="45%"
        @close="detailsList = ''"
        :closeOnClickModal="false"
      >
        <div class="DetailsWater-Dialog" style="margin-bottom: 50px;">
          <div class="DWD-li">
            <div class="DWD-li-title">客户名称</div>
            <div class="DWD-li-text">{{ detailObj.ORMTB431CA03 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">提现类型</div>
            <div class="DWD-li-text">
              {{
                detailObj.ORMTB431CA00 == 'YFTX'
                  ? '运费提现'
                  : detailObj.ORMTB431CA00 === 'YETX'
                  ? '余额提现'
                  : detailObj.ORMTB431CA00 === 'HK'
                  ? '回款'
                  : ''
              }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">实际到账总额</div>
            <div class="DWD-li-text">{{ detailObj.ORMTB431CA01 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">原路退回到账金额</div>
            <div class="DWD-li-text">{{ detailObj.ORMTB431CA06 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">银行卡到账金额</div>
            <div class="DWD-li-text">{{ detailObj.ORMTB431CA07 || '' }}</div>
          </div>

          <div class="DWD-li">
            <div class="DWD-li-title">账号</div>
            <div class="DWD-li-text">{{ detailObj.ORMTB431CA08 || 0 }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">到账时间</div>
            <div class="DWD-li-text">{{ detailObj.ORMTB431CA02 }}</div>
          </div>

          <!-- <div class="DWD-li">
            <div class="DWD-li-title">身份证号</div>
            <div class="DWD-li-text">{{ detailObj.ORMTB410ID || 0 }}</div>
          </div> -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PerformanceRecords',
  data() {
    return {
      isorderAuditText: '',
      sjtxje: '',
      sjtxjenotes: '',
      ORMTB421ID: '',
      txlx: '',
      ORMTB429CA10: '',
      oerderDetilsShow: false,
      isorderAuditShow: false,
      uobj: this.$store.state.uobj, //登陆缓存--用户信息
      date: [], //日期
      dateNowDayActive: false,
      dateYesterdayActive: false,
      dateNowMonthActive: false,
      dateLastMonthActive: false,
      tableData: [],
      materialOptions: [],
      materialTypeValue: '',
      customerOptions: [],
      carNum: '',
      materielMo: '',
      materielOptions: [
        {
          value: 'YFTX',
          label: '运费提现',
        },
        {
          value: 'YETX',
          label: '余额提现',
        },
        {
          value: 'HK',
          label: '回款',
        },
      ],
      zjr: 0,
      // 查询
      customerMo: '', //客户--查询
      ORMTB421CA14: '', //数据状态
      billOperationAdd: false,
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      currentPage: 1, //设置当前页默认为1
      tableHeadList: [
        {
          prop: 'ORMTB421CA00',
          label: '申请类型',
        },
        {
          prop: 'ORMTB421CA02',
          label: '金额',
        },
        {
          prop: 'ORMTB421CA98',
          label: '可提现金额',
        },

        {
          prop: 'ORMTB421CA14',
          label: '审核状态',
        },
        {
          prop: 'ORMTB421CA16',
          label: '审核时间',
        },
        {
          prop: 'ORMTB421CA17',
          label: '审核人',
        },
      ],
      // 审核
      imageUrl: '',
      // 详情
      billOperationDetails: false,
      detailsList: '', //详情列表
      isRefresh: true,
      isRefreshSetInterval: '',
      // quanpDisabled: false,
      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      // 时间限制
      // 限制开始日期不能超过当前日期
      startDateDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      solelist: [],
      DetailsWaterurl: '',
      DetailsWatersrcList: [],
      detailObj: {},
    }
  },
  created() {
    var list = ''
    list = this.$store.state.solelist
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    } else {
      this.getNowDay()
    }
    var path = this.$route.path
    if (path === '/SalesDispatchManagement') {
      path = '/Home' + path
    }
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
  },
  mounted() {
    this.enterprise0ptions()
    this.pageList()
  },
  // 存储数据
  beforeDestroy() {
    var obj = {
      startTime: [this.date[0], this.date[1]], //开始时间
      customerMo: this.customerMo, //申请人
      materielMo: this.materielMo, //申请类型
      ORMTB421CA14: this.ORMTB421CA14, //审核状态
      currentPage: this.currentPage, //当前页数
      pageMo: this.pageMo, //页码
      limitMo: this.limitMo, //每页条数
      dateNowDayActive: this.dateNowDayActive,
      dateYesterdayActive: this.dateYesterdayActive,
      dateNowMonthActive: this.dateNowMonthActive,
      dateLastMonthActive: this.dateLastMonthActive,
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },
  methods: {
    //初始化数据
    init() {
      this.date = this.historyInfo.startTime
      this.customerMo = this.historyInfo.customerMo
      this.materielMo = this.historyInfo.materielMo
      this.ORMTB421CA14 = this.historyInfo.ORMTB421CA14
      this.currentPage = this.historyInfo.currentPage
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
      this.dateNowDayActive = this.historyInfo.dateNowDayActive
      this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
      this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
      this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
    },
    // 上传图片
    handleChangeAdd(file, image) {
      this.imageUrl = image
      // console.log(this.imageUrl)
    },
    // 导出
    exports() {
      var startTime = this.date[0] //开始时间
      var endTime = this.date[1] //结束时间
      var ORMTB429CA10 = this.ORMTB429CA10 //手机号
      var ORMTB410ID = this.customerMo //客户
      var TXLX = this.txlx

      var url =
        this.axios.defaults.baseURL +
        '/exc/toExcel/ormtb431toExcle?startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&ORMTB429CA10=' +
        ORMTB429CA10 +
        '&ORMTB410ID=' +
        ORMTB410ID +
        '&TXLX=' +
        TXLX
      window.location.href = url
    },
    // 申请人--查询
    enterprise0ptions() {
      var List = [
        {
          ORMTB421CA08: '',
          ORMTB421CA06: '全部',
        },
      ]
      var url = '/orm/ormtb421/selectOrmtb421CA06List'
      this.axios.post(url).then(res => {
        // console.log(res)
        if (res.data.code == 200) {
          this.customerOptions = [...List, ...res.data.data]
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    // 查询
    queryClick() {
      this.pageList()
    },
    // 列表
    pageList() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      console.log(this.date)

      const postData = {
        ORMTB410ID: this.customerMo, //申请人ID
        ORMTB429CA10: this.ORMTB429CA10,
        page: this.pageMo,
        limit: this.limitMo,
        TXLX: this.txlx, //提现类型:YF 、 YE
        startTime: this.date[0],
        endTime: this.date[1],
      }

      this.tableData = []
      const url = '/orm/ormtb431/selectPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          console.log(res)

          if (res.data.code == 200) {
            var data = res.data.data.list
            this.zjr = res.data.data.sum
            this.tableData = data
            this.pagingPageMo = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    // 详情
    DetailsClick(row) {
      this.oerderDetilsShow = true
      this.querydetileTX(row)
    },
    isorderAudit(row) {
      this.isorderAuditShow = true
      this.ORMTB421ID = row.ORMTB421ID
      this.querydetileTX(row)
    },
    isorderAuditServe(type) {
      if (type == 2) {
        if (this.isorderAuditText.trim().length == 0)
          return this.$message.error('请填写审核备注')
      }
      // console.log(this.imageUrl)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var formdata = new FormData()
      formdata.append('ORMTB421CA14', type)
      formdata.append('ORMTB421CA08', this.detailsList.ORMTB421CA08)
      formdata.append('ORMTB421CA02', this.detailsList.ORMTB421CA02)
      formdata.append('ORMTB421CA09', this.detailsList.ORMTB421CA06)
      formdata.append('ORMTB421ID', this.ORMTB421ID)
      formdata.append('ORMTB421CA18', this.isorderAuditText)
      formdata.append('ORMTB421CA21', this.sjtxje)
      formdata.append('ORMTB421CA22', this.sjtxjenotes)
      if (this.imageUrl != '') {
        this.imageUrl.forEach(item => {
          formdata.append('file', item.raw)
        })
      } else {
        formdata.append('file', '')
      }
      this.tableData = []
      if (this.detailsList.ORMTB421CA07 == '司机') {
        var url = '/orm/ormtb421/examine'
      } else {
        var url = '/orm/ormtb421/examineOrmtb410'
      }
      this.axios
        .post(url, formdata, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          // console.log(res)
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.isorderAuditShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 提现详情
    querydetileTX(row) {
      this.detailObj = row
    },
    //获取当前时间
    getNowDay() {
      var date = new Date().getTime()
      var nowDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(date))
      this.date = [nowDay, nowDay]
      this.dateNowDayActive = true
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    datePickerChange(e) {
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取昨天时间
    getYesterday() {
      var hms = new Date().getTime() - 86400000
      var nowDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(hms))
      this.date = [nowDay, nowDay]
      this.dateNowDayActive = false
      this.dateYesterdayActive = true
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取当月时间
    sameMonth() {
      var date = new Date()
      var hms = date.setDate(1)
      var firstDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(hms))
      var nextdate = new Date().getTime()
      var nextDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(nextdate))
      this.date = [firstDay, nextDay]
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = true
      this.dateLastMonthActive = false
    },
    //获取上月时间
    lastMonth() {
      var nowdays = new Date()
      var year = nowdays.getFullYear()
      var month = nowdays.getMonth()
      if (month == 0) {
        month = 12
        year = year - 1
      }
      if (month < 10) {
        month = '0' + month
      }
      var firstDayOfPreMonth = year + '-' + month + '-' + '01'
      var lastDay = new Date(year, month, 0)
      let lastDayOfPreMonth = year + '-' + month + '-' + lastDay.getDate()
      this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = true
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
  },
}
</script>

<style scoped>
.CustomerfillingDig-tab {
  padding-left: 20px;
}

.public_criteriaRange /deep/ .el-input__inner {
  height: 1.7vw;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
  display: flex;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #333;
  vertical-align: top;
}

.CustomerfillingDig-tab-li > div {
  border: 1px solid #cdcdcd;
  border-top: none;
}

.CustomerfillingDig-tab-li > div:first-child {
  border-right: none;
}

.CustomerfillingDig-tab-li:first-child > div {
  border-top: 1px solid #cdcdcd;
}

.CustomerfillingDig-tab-li > div:last-child,
.rechargeType-tab-li > div:last-child {
  border: none;
  color: #ff4d35;
}

.CustomerfillingDig-tab-li-text {
  flex: 0.8;
  background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
  flex: 0.8;
}

.rechargeType-tab-li-text {
  flex: 0.35;
}

.rechargeType-tab-li-ipt {
  flex: 0.7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
  height: 46px;
  width: 100%;

  text-align: center;

  box-sizing: border-box;
  font-size: 16px;
  color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
  outline: none;
  border: none;
  vertical-align: top;
}

.rechargeType-tab-li-ipt input {
  /* border-radius: 8px; */
  /* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
  flex: 0.3;
}

.CustomerfillingDig-tab-btn {
  text-align: center;
  margin-top: 30px;
}

.DWD-li {
  display: flex;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  border: 1px solid #999;
  font-size: 16px;
  color: #333;
}

.DWD-li > div {
  padding: 0 5px;
  height: 34px;
  overflow: hidden;
  box-sizing: border-box;
}

.DWD-li-title {
  width: 150px;
  text-align: center;
  border-right: 1px solid #999;
  background-color: rgba(0, 163, 255, 0.1);
}
.right_btn {
  float: right;
  margin-bottom: 10px;
}

.DWD-li-text {
  flex: 1;
}

.DWD-li-text input {
  width: 100%;
  height: 35px;
  line-height: 35px;
  border: none;
  outline: none;
}

.DWD-li + .DWD-li {
  border-top: none;
}

.DWD-table {
  display: flex;
}

.DWD-table-left-flex {
  flex: 1;
}

.DWD-table > div > div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
  box-sizing: border-box;
}

.DWD-table > div > div:first-child {
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title > div {
  width: 101px;
  text-align: center;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title > div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  box-sizing: border-box;
  border-left: 1px solid #999;
  border-bottom: 1px solid #999;
}

.DetailsWater-img {
  margin-top: 30px;
}

.DetailsWater-img-text {
  display: inline-block;
  width: 101px;
  text-align: center;
  vertical-align: top;
}

.car-number-add {
  /* text-transform: uppercase; */
}

.billOperationRecord-table {
  padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
  background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
  flex: 1.5;
}

.fontBlue {
  color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
  height: 45px;
  align-items: center;
}

.billOperationRecord {
  background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
  text-align: center !important;
}
</style>
